import { Dropdown, AutoCompleteDropdown, TextField, DatePicker, MultiSelectNew } from "app/components/CustomFormElements/syncFusionFormFields";
import { investmentValidationSchema } from "app/helper/validationSchema/companyValidationSchema";
import { useFormik } from "formik";
import * as Yup from "yup";
import { actionError, actionSuccess, showLoader, hideLoader } from "middleware/actions/utilityAction";
import { fetchCompany, fetchInvestment, fetchSingleCompany, saveInvestment, editInvestment } from "middleware/services/companyApi";
import { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBreadCrumb } from "middleware/actions/breadCrumbAction";
import { useHistory } from "react-router-dom";
import fundingTypeOptions from "../../../../constants";
import { getProductVariant } from "../../../../../../../utilities";
import moment from "moment";
import { debounce } from "lodash";

const CompanyBasicFunding = (props) => {
  const { companyId, investmentId } = props.computedMatch.params || {};
  const [companyName, setCompanyName] = useState("");
  const [companyInvestment, setCompanyInvestment] = useState([]);

  const [oldData, setOldData] = useState(null);
  const split_url = props.location?.pathname.split("/");

  const backPath = investmentId ? `${split_url.slice(0, -3).join("/")}/edit#basic` : `${split_url.slice(0, -2).join("/")}/edit#basic`;

  const dispatch = useDispatch();
  const history = useHistory();

  const breadCrumbLinks = [
    { linkUrl: "/company", linkName: `Company`, linkActive: false },
    { linkUrl: `/company/${companyId}/edit#basic`, linkName: companyName, linkActive: false },
    { linkUrl: `/company/${companyId}/edit#basic`, linkName: "Basic", linkActive: false },
    { linkUrl: ``, linkName: "Investment", linkActive: true },
  ];

  const initialFormValues = {
    fundingName: "",
    fundingAmount: "",
    fundingTypeRound: "",
    fundingOnCompanyName: "",
    fundingDate: "",
  };

  const formik = useFormik({
    initialValues: oldData || initialFormValues,
    validationSchema: Yup.object().shape(investmentValidationSchema),
    enableReinitialize: true,
  });

  const searchInvestors = useCallback(
    debounce(async (e) => {
      if (e.text.length > 2) {
        let filters = [];
        const productVariant = getProductVariant();
        if (productVariant) filters.push(["productVariant.productName", "eq", productVariant]);
        filters.push(["companyName", "cn", e.text]);
        let fields = { fields: ["companyId", "companyName"] };
        const response = await fetchCompany({ filters: filters, ...fields });
        if (response.data && response.data.data) {
          const resData = response.data.data.map((v) => {
            return { label: v.companyName, value: v.id };
          });
          if (resData) {
            e.updateData(resData);
          } else {
            e.updateData([]);
          }
        }
      }
    }, 300),
    []
  );

  const getCompanyName = async () => {
    if (companyId) {
      const fields = { fields: ["id", "companyName"] };
      const response = await fetchSingleCompany(companyId, { ...fields });
      setCompanyName(response.data.data.companyName);
    }
  };

  // save investment
  const handleSaveInvestment = async () => {
    formik.validateForm().then((res) => {
      if (Object.keys(res).length) {
        const touched = {};
        Object.keys(res).map((field) => {
          touched[field] = true;
          return touched;
        });
        formik.setFormikState({ ...formik, touched: touched, errors: res });
      } else {
        dispatch(showLoader());
        let payload = formik.values;
        payload.fundingAmount = payload.fundingAmount == "NA" ? payload.fundingAmount : +payload.fundingAmount;
        payload.fundingInvestors = [{ companyId, companyName }];
        let fundingOnCompanyId;
        if (payload.fundingOnCompanyName !== companyInvestment.label) {
          fundingOnCompanyId = [
            {
              companyName: payload.fundingOnCompanyName,
            },
          ];
        } else {
          fundingOnCompanyId = [
            {
              companyName: companyInvestment.label,
              companyId: companyInvestment.value,
            },
          ];
        }
        payload.fundingOnCompanyId = fundingOnCompanyId;
        delete payload.fundingOnCompanyName;
        // temporary fix
        payload.fundingId = Math.random().toString(36).substring(2, 15);
        payload.fundingDate = moment(payload.fundingDate).format("DD-MMM-yyyy");
        saveInvestment(payload)
          .then((response) => {
            dispatch(hideLoader());
            dispatch(actionSuccess("Investment added Successfully"));
            history.push(backPath);
          })
          .catch((err) => {
            dispatch(hideLoader());
            dispatch(actionError(err?.data?.message || "Someting went wrong"));
          });
      }
    });
  };

  const handleEditInvestment = async () => {
    formik.validateForm().then((res) => {
      if (Object.keys(res).length) {
        const touched = {};
        Object.keys(res).map((field) => {
          touched[field] = true;
          return touched;
        });
        formik.setFormikState({ ...formik, touched: touched, errors: res });
      } else {
        dispatch(showLoader());
        let payload = formik.values;
        payload.fundingAmount = payload.fundingAmount == "NA" ? payload.fundingAmount : +payload.fundingAmount;
        payload.fundingInvestors = [{ companyId, companyName }];
        let fundingOnCompanyId;
        if (payload.fundingOnCompanyName !== companyInvestment.label) {
          fundingOnCompanyId = [
            {
              companyName: payload.fundingOnCompanyName,
            },
          ];
        } else {
          fundingOnCompanyId = [
            {
              companyName: companyInvestment.label,
              companyId: companyInvestment.value,
            },
          ];
        }
        payload.fundingOnCompanyId = fundingOnCompanyId;
        delete payload.fundingOnCompanyName;
        // temporary fix
        payload.fundingId = Math.random().toString(36).substring(2, 15);
        delete new Date(payload.fundingCreatedDate);
        delete new Date(payload.fundingUpdatedDate);
        delete payload.id;
        editInvestment(investmentId, payload)
          .then((response) => {
            dispatch(hideLoader());
            dispatch(actionSuccess("Investment updated successfully"));
            history.push(backPath);
          })
          .catch((err) => {
            dispatch(hideLoader());
            console.log(err.data);
            dispatch(actionError(err?.data?.message || "Someting went wrong"));
          });
      }
    });
  };

  const setFormikValues = (data) => {
    const oldData = {
      fundingName: data.fundingName || "",
      fundingAmount: data.fundingAmount || "",
      fundingTypeRound: data.fundingTypeRound || "",
      fundingDate: data.fundingDate || "",
      fundingOnCompanyName: data.fundingOnCompanyId?.[0]?.companyName || "",
    };
    setOldData(oldData);
    setTimeout(() => {
      formik.setValues(oldData);
    }, 1);
  };

  useEffect(() => {
    if (props.editData && companyId && investmentId) {
      formik.resetForm();
      fetchInvestment(companyId)
        .then((res) => {
          let investmentData = res.data?.data?.filter((e) => e.id === investmentId)?.[0] || {};
          setCompanyInvestment({
            label: investmentData.fundingOnCompanyId?.[0]?.companyName || "",
            value: investmentData.fundingOnCompanyId?.[0]?.companyId || "",
          });
          setFormikValues(investmentData);
        })
        .catch((err) => {
          dispatch(actionError(err?.data?.message || "Something went wrong"));
        });
    } else {
      formik.resetForm();
    }
  }, [props.editData, companyId, investmentId]);

  useEffect(() => {
    dispatch(setBreadCrumb(breadCrumbLinks));
  }, [breadCrumbLinks]);

  useEffect(() => {
    getCompanyName();
  }, [companyId]);

  return (
    <div className="p-0 m-3 company-basic-modal">
      <div className="modal-header">Company - Investment</div>
      <div className="modal-body">
        <div className="row pl-3 pt-3 pr-3">
          <div className="col-md-4">
            <div className="form-group required">
              <TextField
                formik={formik}
                type="text"
                className="form-control"
                id="fundingName"
                placeholder="Enter Transaction Name *"
                name="fundingName"
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group required">
              <DatePicker
                formik={formik}
                properties={{
                  placeholder: "Enter Transaction Date *",
                  id: `fundingDate`,
                  name: `fundingDate`,
                  format: "dd MMM yyyy",
                  floatLabelType: "Auto",
                  allowEdit: false,
                  openOnFocus: true,
                  // max: new Date()
                }}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group required">
              <TextField
                formik={formik}
                type="text"
                className="form-control"
                id="fundingAmount"
                placeholder="Enter Transaction Amount (NA if amount not available) *"
                name="fundingAmount"
              />
            </div>
          </div>
        </div>
        <div className="row pl-3 pr-3">
          <div className="col-md-4">
            <div className="form-group required">
              <Dropdown
                formik={formik}
                sortOrder="Acending"
                placeholder="Select Funding Type *"
                id="fundingTypeRound"
                name="fundingTypeRound"
                fields={{ text: "label", value: "value" }}
                dataSource={fundingTypeOptions}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group required">
              <AutoCompleteDropdown
                formik={formik}
                id="fundingOnCompanyName"
                name="fundingOnCompanyName"
                placeholder="Company *"
                fields={{ value: "label", id: "value" }}
                filtering={searchInvestors}
                select={(data) => {
                  data && data?.itemData && setCompanyInvestment(data?.itemData);
                }}
                allowFiltering={true}
              />
            </div>
          </div>
        </div>

        <div className="text-right border-top p-3 mt-auto">
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              history.push(backPath);
            }}
            className="btn btn-outline-dark mr-3"
          >
            Cancel
          </button>

          {true ? (
            <button type="button" className="btn btn-primary" onClick={props.editData ? handleEditInvestment : handleSaveInvestment} disabled={false}>
              {props?.editData ? "Update" : "Save"}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CompanyBasicFunding;
